import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=38fd13d8&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style1 from "./Home.vue?vue&type=style&index=1&id=38fd13d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd13d8",
  null
  
)

export default component.exports